<div class="control-card-header">
  <div id="header">
    <ng-container i18n="@@usersimportdialog_title">Importazione utenti</ng-container>
    <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
  </div>
</div>


<div fxLayout="column" fxLayoutAlign="space-around none" class="control-card-content" *ngIf="showGuidePage">

  <div id="guideDiv">
    <ng-container i18n="@@usersimportdialog_guide">Inserimento automatico utenti</ng-container>
    <br>
    <ng-container i18n="@@usersimportdialog_guide2">Se l'utente non fa parte di alcun gruppo, indicare 0, altrimenti
      inserire il nome assegnato al gruppo.</ng-container>
    <br>
    <ng-container i18n="@@usersimportdialog_guide3">Il prefisso non deve contenere il + iniziale</ng-container>


    <div class="control-card-buttons" div fxLayout="row" fxLayoutAlign="center center">
      <div fxLayout="row">
        <a id="confirmButton" class="button" href="../../assets/users-import-example.csv" download>
          <ng-container i18n="@@usersimportdialog_download_example">Scarica file esempio</ng-container>
          <span>
            <fa-icon icon="download"></fa-icon>
          </span>
        </a>
      </div>
    </div>
  </div>

  <div id="fileUploadDiv">
    <ng-container i18n="@@usersimportdialog_upload">Caricamento file:</ng-container>
    <input class="form-control mb-5" type="file" class="upload" (change)="changeListener($event.target.files)">

    <p class="text-small text-error margin-top-10 display-inline" *ngIf="groupNotFoundError" i18n="@@usersimportdialog_group_not_found_error">
      Il gruppo {{errorString}} non risulta presente fra i gruppi esistenti
    </p>

    <p class="text-small text-error margin-top-10 display-inline" *ngIf="noGroupError" i18n="@@usersimportdialog_no_group_error">
      Per un utente inserito non é stato specificato il gruppo, ricontrollare il file
    </p>


    <p class="text-small text-error margin-top-10 display-inline" *ngIf="noNameError" i18n="@@usersimportdialog_no_name_error">
      Per un utente inserito non é stato specificato il nome, ricontrollare il file
    </p>

    <p class="text-small text-error margin-top-10 display-inline" *ngIf="methodDuplicateError" i18n="@@usersimportdialog_method_duplicate_error">
      Il metodo con codice {{errorString}} risulta inserito più volte, ricontrollare il file
    </p>

    <p class="text-small text-error margin-top-10 display-inline" *ngIf="methodAlreadyExistsError" i18n="@@usersimportdialog_method_already_exists_error">
      Il metodo con codice {{errorString}} risulta associato ad un utente esistente, ricontrollare il file
    </p>

    <p class="text-small text-error margin-top-10 display-inline" *ngIf="invalidPhoneNumberError" i18n="@@usersimportdialog_invalid_phone_number_error">
      Il numero di telefono {{errorString}} risulta non valido, ricontrollare il file
    </p>
  </div>
</div>


<div class="table-container" [hidden]="!showConfirmPage">

  <div id="tableDiv">
    <table #usersToImportTable mat-table matSort class="simple-table">

      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@usersimportdialog_name" style="width: 25%;">Nome</th>
        <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@usersimportdialog_description" style="width: 25%;">
          Descrizione</th>
        <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
      </ng-container>

      <ng-container matColumnDef="groupName">
        <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@usersimportdialog_group" style="width: 25%;">Gruppo</th>
        <td mat-cell *matCellDef="let element">
          {{ element.groupName }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>


  <div class="control-card-buttons">
    <a id="confirmImportButton" class="button" (click)="confirmImport()">
      <ng-container i18n="@@usersimportdialog_confirm_import">Conferma</ng-container>
      <span>
        <fa-icon icon="check"></fa-icon>
      </span>
    </a>

    <a id="cancelImportButton" class="button button-red" (click)="closeDialog()">
      <ng-container i18n="@@usersimportdialog_cancel_import">Annulla</ng-container>
      <span>
        <fa-icon icon="times"></fa-icon>
      </span>
    </a>
  </div>
</div>




<div class="control-card-content" *ngIf="showCreatingUsersPage">

  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <ng-container i18n="@@usersimportdialog_creating_users">Importazione utenti in corso</ng-container>
    </div>
  </div>
  <br>
  <br>
  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <br>
  <br>
  <br>
  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <ng-container>{{createdUsersStrComplete}}</ng-container>
    </div>
  </div>
</div>

<div class="control-card-content" *ngIf="showUpdatingUsersPermissionsPage">

  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <ng-container i18n="@@usersimportdialog_updating_users_permissions">Caricamento metodi d'accesso</ng-container>
    </div>
  </div>
  <br>
  <br>
  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <br>
  <br>
  <br>
  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <ng-container>{{updatingAccessMethodsComplete}}</ng-container>
    </div>
  </div>
</div>

<div class="control-card-content" *ngIf="showErrorPage">

  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <ng-container i18n="@@usersimportdialog_error">Si é verificato un problema
      </ng-container>
    </div>
  </div>
  <br>
  <br>
  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <fa-icon icon="times" style="color : red;" size="5x"></fa-icon>
    </div>
  </div>
  <br>
  <br>
  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <ng-container i18n="@@usersimportdialog_try_again">Si prega di riprovare più tardi.</ng-container>
    </div>
  </div>
  <br>
  <br>

</div>


<div class="control-card-content" *ngIf="showCreationSuccessfullPage">

  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <ng-container i18n="@@usersimportdialog_creation_successfull">L'importazione degli utenti é andata a buon fine.
      </ng-container>
    </div>
  </div>
  <br>
  <br>
  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <fa-icon icon="check" style="color : green;" size="5x"></fa-icon>
    </div>
  </div>
  <br>
  <br>
  <div div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="row">
      <a (click)="closeDialog()" class="button" id="confirmButton">
        <ng-container>OK</ng-container>
        <span>
          <fa-icon icon="check"></fa-icon>
        </span>
      </a>
      <!-- <ng-container i18n="@@usersimportdialog_page_will_reload">La pagina verrà ricaricata</ng-container> -->
    </div>
  </div>
  <br>
  <br>
</div>